module.exports = __webpack_public_path__ + "static/media/maleAvatarPlaceholder.cec4ccb3.png";